import React from "react";
import { LegalHero, LegalBody, H2, LastUpdated } from "./legalHelpers";
import { usePageMeta } from "../components/Layout";


export default function FreeDesignTermsPage() {
    usePageMeta({
        title: "Free Design Terms | London Renovation Specialists",
        description: "The terms on which London Renovation Specialists provides its free design service.",
    });
    return (
        <div data-testid="free-design-terms-page">
            <LegalHero
                eyebrow="Terms"
                title="Free Design Terms"
                intro="The terms on which London Renovation Specialists provides its free design service."
            />
            <LegalBody>
                <LastUpdated />


                <H2>Offer</H2>
                <p>
                    The free design service is offered subject to project feasibility. We reserve the right to
                    decline projects that are not suitable for the free service.
                </p>


                <H2>Eligible projects</H2>
                <p>The free design service applies to residential:</p>
                <ul className="list-disc pl-6 space-y-2">
                    <li>rear extensions;</li>
                    <li>side extensions;</li>
                    <li>loft conversions and loft extensions;</li>
                    <li>internal reconfigurations.</li>
                </ul>


                <H2>Scope</H2>
                <p>
                    The service covers concept / feasibility stage architectural layout drawings. The precise scope
                    will depend on the property and the proposed works.
                </p>


                <H2>Surveys</H2>
                <p>
                    The free design service is based on existing floor plans / estate agent plans that you provide
                    us. Should you require additional services from us that require a site visit, this can be
                    discussed and agreed separately.
                </p>


                <H2>Exclusions</H2>
                <p>The free design service does not include:</p>
                <ul className="list-disc pl-6 space-y-2">
                    <li>planning drawings;</li>
                    <li>planning submission and planning management;</li>
                    <li>measured surveys and site visits;</li>
                    <li>structural engineering;</li>
                    <li>structural calculations;</li>
                    <li>Building Regulations packages;</li>
                    <li>technical construction drawings;</li>
                    <li>Party Wall services;</li>
                    <li>Thames Water / build-over applications;</li>
                    <li>specialist consultant reports;</li>
                    <li>specialist planning services;</li>
                    <li>heritage reports;</li>
                    <li>statutory or application fees;</li>
                    <li>Building Control fees;</li>
                    <li>specifications;</li>
                    <li>tender packages;</li>
                    <li>detailed interior design;</li>
                    <li>contract administration.</li>
                </ul>


                <H2>Planning</H2>
                <p>
                    Planning drawings, planning submission and planning management are not included in the free
                    design service. No planning permission or statutory approval is guaranteed as part of the service.
                </p>


                <H2>No obligation</H2>
                <p>
                    There is no obligation to appoint London Renovation Specialists to take the design work further
                    or to carry out the construction works.
                </p>
                <p>
                    No retrospective design fee becomes payable simply because another designer or contractor is
                    subsequently appointed.
                </p>


                <H2>Drawings</H2>
                <p>
                    The drawings issued as part of the free design service are concept / feasibility stage
                    information only and are not suitable for construction. Planning drawings, technical design,
                    structural information and Building Regulations information will be required before
                    construction work starts.
                </p>


                <H2>Copyright and licence</H2>
                <p>Copyright in the drawings remains with the designer.</p>
                <p>
                    Once issued, the homeowner receives a royalty-free licence to use the drawings in connection
                    with the relevant property, including if they subsequently appoint another designer or
                    contractor.
                </p>


                <H2>Geography</H2>
                <p>The free design service operates across all of London and the surrounding areas.</p>


                <H2>Legal operator</H2>
                <p>
                    London Renovation Specialists is a trading name of Studio G4 Ltd,
                    a company registered in England and Wales under company number{" "}
                    12308705, with office at{" "}
                    10 Barley Mow Passage, Chiswick, London, W4 4PH.
                </p>
            </LegalBody>
        </div>
    );
}
